import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { queries } from "@/apollo";
import { customMoment } from "@/main";
import { User } from "@/CodegenTypes";
import { formatDollar } from "@/helpers/formatDollar";
import { formatCount } from "@/helpers/formatCount";
import { startCase, sortBy, groupBy, uniq } from "lodash";
import PageDetailsModal from "../bet-details/PageDetailsModal.vue";
import DeletePageModal from "../bet-details/DeletePageModal.vue";
import { useTranslation } from "@/store/translation";

type ProcessedPage = {
  id: string;
  name: string;
  enteredFrom: string;
  enteredById: string;
  createdAt: string;
  releaseDates: string[];
  calculation: {
    bigCount: number;
    smallCount: number;
    rawCost: number;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewBetModal',
  props: {
    value: { type: Boolean, default: false },
    userId: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, userId: User["userId"] };





const { $t } = useTranslation();
const t = (text: string) => $t(text);

const selectedPage = ref<null | ProcessedPage>(null);
const showPageDetailModal = ref(false);
const showDeletePageModal = ref(false);

const releaseDateStart = customMoment()
  .startOf("day")
  .toDate();

const releaseDateEnd = customMoment()
  .add(2, "weeks")
  .startOf("day")
  .toDate();

const queryVariables = computed(() => ({
  releaseDateStart,
  releaseDateEnd,
  behalfOf: props.userId,
}));

const { result, loading: apolloLoading, refetch } = useQuery<{ user: User }>(
  queries.userPages,
  queryVariables,
  {
    enabled: computed(() => !!props.userId && !!props.value),
    fetchPolicy: "no-cache",
  }
);

const user = computed(() => result.value?.user ?? null);

const processedPages = computed<ProcessedPage[]>(() => {
  const pages = Object.entries(groupBy(user.value?.pages ?? [], (page) => page.id)).map(([, pages]) => {
    return {
      ...pages[0],
      releaseDates: uniq(pages.map((page) => page.releaseDate)),
      calculation: pages.reduce(
        (acc, page) => {
          return {
            bigCount: acc.bigCount + page.calculation.bigCount,
            smallCount: acc.smallCount + page.calculation.smallCount,
            rawCost: acc.rawCost + page.calculation.rawCost,
          };
        },
        {
          bigCount: 0,
          smallCount: 0,
          rawCost: 0,
        }
      ),
    };
  });

  return sortBy(pages, (page) => -customMoment(page.createdAt).unix());
});

function toggleModal(val: boolean) {
  emit("input", val);
}

function openPage(page: ProcessedPage) {
  selectedPage.value = page;
  showPageDetailModal.value = true;
}

function handleSubmit() {
  toggleModal(!props.value);
}

function formatDatetime(dateStr: string | Date) {
  return customMoment(dateStr).fromNow();
}

function formatReleaseDate(dateStr: string | Date) {
  return customMoment(dateStr).format("ddd, DD/MM/YYYY");
}

function deletePage(pageId: string) {
  selectedPage.value = processedPages.value.find((page) => page.id === pageId) || null;
  if (!selectedPage.value) {
    return;
  }
  showDeletePageModal.value = true;
}

function reloadAll() {
  refetch(queryVariables.value);
}

return { __sfc: true,props, emit, $t, t, selectedPage, showPageDetailModal, showDeletePageModal, releaseDateStart, releaseDateEnd, queryVariables, result, apolloLoading, refetch, user, processedPages, toggleModal, openPage, handleSubmit, formatDatetime, formatReleaseDate, deletePage, reloadAll, formatDollar, formatCount, startCase, PageDetailsModal, DeletePageModal }
}

})